module.exports = ".notifications-dropdown {\n  min-height: 8rem;\n  height: auto;\n  width: 25rem;\n  top: 2rem;\n  left: -22rem;\n  border-top: 0;\n  overflow: auto !important; }\n\n.notifications-empty {\n  text-align: center;\n  margin-top: 3rem; }\n\n.no-margin-bottom {\n  margin-bottom: 0; }\n\n.load-more {\n  text-align: center;\n  border-top: 1px solid #cfd8dc; }\n\n.no-top-border {\n  border-top: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/notifications/notifications.component.scss
// module id = ./src/app/notifications/notifications.component.scss
// module chunks = main